module.exports = __webpack_public_path__ + "media/images/expert__lutz-pfannenstiel-774aecb02fa13c7a14d27c1401aeb8bf.png";